import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { TopicCard, LoadingBlock } from "@/components/site/Cards";

export default function Topics() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/topics").then((r) => setTopics(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="topics-page">
      <section className="border-b border-oc-hairline">
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16 md:py-24">
          <div className="eyebrow text-oc-coral mb-6">Browse by problem</div>
          <h1 className="hero-headline text-5xl md:text-7xl text-oc-ink max-w-4xl">
            The problems operators keep having to solve.
          </h1>
          <p className="mt-6 font-editorial text-xl text-oc-ink-soft max-w-2xl leading-snug">
            Pick a real problem. See the interviews, contributors, and frameworks that address it, straight from operators who&#39;ve worked on the same question.
          </p>
        </div>
      </section>
      <section>
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16">
          {loading ? (
            <LoadingBlock />
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {topics.map((t) => <TopicCard key={t.slug} topic={t} />)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
